/**
 * Build a list of years centred on the current year.
 *
 * @param {number} back   How many years before the current year to include.
 * @param {number} ahead  How many years after the current year to include.
 * @param {object} [opts]
 * @param {boolean} [opts.asStrings=true]  
 * @param {boolean} [opts.descending=false] Newest first.
 * @returns {(number|string)[]}
 *
 * @example
 */
export function yearRange(back = 5, ahead = 5, opts = {}) {
  const { asStrings = true, descending = false } = opts;
  const current = new Date().getFullYear();

  const years = [];
  for (let y = current - back; y <= current + ahead; y++) {
    years.push(asStrings ? String(y) : y);
  }

  return descending ? years.reverse() : years;
}

/**
 * current year
 */
export const currentYear = String(new Date().getFullYear());

export const YEARS = yearRange(5, 5);